import React from 'react';
import './toggle.scss';

export default class Toggle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeButtonWidth: 'auto',
            activeButtonLeft: 'auto'
        }
    }

    static defaultProps = {
        active: 0,
        left: 'LEFT',
        right: 'RIGHT'
    }

    componentDidMount() {
        this.resetActiveButtonWidth(this.props.active);
    }

    componentDidUpdate(prevProps) {
        if (this.props.active !== prevProps.active) {
            this.resetActiveButtonWidth(this.props.active);
        }
    }

    render() {
        const activeButtonStyle = {
            width: `${this.state.activeButtonWidth}px`,
            left: `${this.state.activeButtonLeft}px`
        }

        return (
            <div className='pubhub-agenda-toggle'>
                <div className={'box' + (this.props.active ? ' right-active' : '')}>
                    <div ref={dom => this.left = dom} className='left' onClick={this.onChangeToLeft}>
                        <div className='text'>{this.props.left}</div>
                    </div>
                    <div ref={dom => this.right = dom} className='right' onClick={this.onChangeToRight}>
                        <div className='text'>{this.props.right}</div>
                    </div>
                    <div className='active-button-bg' style={activeButtonStyle}></div>
                </div>
            </div>
        );
    }

    resetActiveButtonWidth(active) {
        const DEFAULT_LEFT_WIDTH = 80; // width for "ALL"
        if (!this.left || !this.right) return;
        const left = this.left.getBoundingClientRect();
        const right = this.right.getBoundingClientRect();
        const leftWidth = left.width || DEFAULT_LEFT_WIDTH;
        const rightWidth = right.width;
        const activeButtonWidth = active ? rightWidth : leftWidth;
        const activeButtonLeft = active ? leftWidth : 0; 
        this.setState({ activeButtonWidth, activeButtonLeft });
    }

    onChangeToLeft = () => {
        this.props.active && this.props.onChange && this.props.onChange(false);
    }

    onChangeToRight = () => {
        !this.props.active && this.props.onChange && this.props.onChange(true);
    }
}